import React, { useState, useEffect } from "react";
import {
    LiveKitRoom,
    RoomAudioRenderer,
    useVoiceAssistant,
    BarVisualizer,
    VoiceAssistantControlBar,
    DisconnectButton,
} from "@livekit/components-react";

import "@livekit/components-styles";
import { CloseIcon } from "../components/CloseIcon";
import axios from "axios";
import Loading from "../components/Loading";
import { useKrispNoiseFilter } from "@livekit/components-react/krisp";

export default function Voice() {
    const [agentState, setAgentState] = useState("disconnected");
    const [token, setToken] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        // Fetch the token from the API
        const fetchToken = async () => {
            try {
                const userId = localStorage.getItem("userId");
                const response = await axios.get(
                    `${apiUrl}/voice/token/${userId}`
                );
                if (response.data.token) {
                    setToken(response.data.token);
                } else {
                    console.error("Token not found in response");
                }
            } catch (error) {
                console.error("Error fetching token:", error);
            }
        };

        fetchToken();
    }, []);

    if (!token) {
        return <Loading />;
    }

    return (
        <LiveKitRoom
            token={token}
            serverUrl={process.env.REACT_APP_LIVEKIT_SERVER_URL}
            video={false}
            audio={true}
            onMediaDeviceFailure={onDeviceFailure}
            data-lk-theme="default"
            className="flex flex-col items-center justify-center"
            style={{ height: "100vh" }}
        >
            <SimpleVoiceAssistant onStateChange={setAgentState} />
            <RoomAudioRenderer />
            <VoiceAssistantControlBar controls={{ leave: false }} />
            <DisconnectButton aria-label="Disconnect from voice assistant">
                <CloseIcon />
            </DisconnectButton>
        </LiveKitRoom>
    );
}

function SimpleVoiceAssistant(props) {
    const { state, audioTrack } = useVoiceAssistant();
    const krisp = useKrispNoiseFilter();
    useEffect(() => {
        krisp.setNoiseFilterEnabled(true);
    }, []);

    useEffect(() => {
        props.onStateChange(state);
    }, [state]);

    return (
        <div className="h-[300px] max-w-[90vw] mx-auto">
            <div role="status" aria-live="polite" className="sr-only">
                {`Voice assistant is ${state}`}
            </div>
            <BarVisualizer
                state={state}
                barCount={5}
                trackRef={audioTrack}
                className="agent-visualizer"
                options={{ minHeight: 24 }}
            />
        </div>
    );
}

function onDeviceFailure(error) {
    console.error(error);
    alert(
        "Error acquiring camera or microphone permissions. Please make sure you grant the necessary permissions in your browser and reload the tab"
    );
}
